import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../shared/Notification';
import './login.css';


const LoginRecruiter = () => {
    const [error, setError] = useState('');
    const [notification, setNotification] = useState('');
    const [formData, setFormData] = useState({
        emailOrPhone: '',
        password: ''
    });

    const navigate = useNavigate();
    
    useEffect(() => {
        const message = localStorage.getItem('notification');
        if (message) {
            setNotification(message);
            localStorage.removeItem('notification');
        }
    }, []);

    const handleCloseNotification = () => {
        setNotification('');
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    // console.log("API URL:", process.env.REACT_APP_API_URL);
    // console.log("Socket URL:", process.env.REACT_APP_SOCKET_URL);
    const API_URL = process.env.REACT_APP_API_URL; 

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${API_URL}/api/authRecruiter/login`, formData);
            // console.log(response.data);
            // console.log(response.data.message);
            const { token } = response.data;
            localStorage.setItem('token', token); // Save the token in local storage
            localStorage.setItem('notification', 'Successfully LoggedIn !');
            navigate('/recruiter/home');
            
        } catch (error) {
            // const Message = error.response.data.message;
            // console.log('Message:',Message);
            // console.error('error1:',error);
            // const errorMessage2 = error.response?.data?.message || 'An error occurred';
            // setError(errorMessage2);
        }
    }

    return (
        <div className="login-container">
            <form onSubmit={handleSubmit}>
                <h2>Login as Recruiter</h2>
                <input
                    type="text"
                    name="emailOrPhone"
                    placeholder="Email or Phone"
                    value={formData.emailOrPhone}
                    onChange={handleChange}
                    required
                />
                <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                />
                {error && (
                <div className="error-message">
                    <p>{error}</p>
                </div>
                )}
                <button type="submit">Login</button>
                <p>Don't have an account? <a href="/recruiter/signup">Signup</a></p>
                <p><a href='/recruiter/forgot-password'>Forgot Password?</a></p>
            </form>
            {notification && (
                        <Notification message={notification} onClose={handleCloseNotification} />
                    )}
        </div>
    );
};

export default LoginRecruiter;